<template>
    <vue-scroll class="login-page align-vertical">
        <div class="form-wrapper align-vertical-middle">
            <div class="form-box card-base card-shadow--extraLarge">
                <img class="image-logo" src="@/assets/images/logo.png" alt="logo"/>

                <float-label class="styled">
                    <input type="email" v-model="form.email" placeholder="E-mail">
                </float-label>
                <float-label class="styled">
                    <input type="password" v-model="form.password" placeholder="Password">
                </float-label>

                <div class="flex">
                    <div class="box grow">
                        <el-checkbox v-model="form.remember">Remember Me</el-checkbox>
                    </div>
                </div>

                <div class="flex text-center center pt-30 pb-10">
                    <el-button plain size="small" @click="login" class="login-btn tada animated">
                        LOGIN
                    </el-button>
                </div>

            </div>
        </div>
    </vue-scroll>
</template>

<script>
  export default {
    name: 'Login',
    data () {
      return {
        form: {
          email: '',
          password: '',
          remember: false
        },
        redirect: null,
      }
    },
    methods: {
        login() {
        this.redirect = this.$route.query.redirect || '/';

        this.$store.dispatch('Login', this.form)
            .then(() => {
            this.$router.push({ path: this.redirect });
            })
            .catch(() => {
            this.$router.push({ path: this.redirect });
            });
        },
    }
  }
</script>

<style lang="scss">
    @import '../../../assets/scss/_variables';

    .login-page {
        background: $text-color;
        margin-left: -30px;
        margin-right: -30px;

        .form-wrapper {
            width: 100%;
        }

        .form-box {
            width: 100%;
            max-width: 340px;
            padding: 30px;
            box-sizing: border-box;
            margin: 20px auto;

            a {
                font-size: 14px;
                color: $text-color-accent;
                text-decoration: none;
                font-weight: 500;
            }

            .image-logo {
                width: 170px;
                margin: 0px auto;
                margin-bottom: 30px;
                display: block;
            }

            .login-btn,
            .social-btn {
                width: 160px;

                &.google {
                    margin-bottom: 10px;
                    background-color: #d73d32;
                    color: white;

                    &:hover {
                        border-color: #d73d32;
                    }
                }
                &.facebook {
                    background-color: #3f5c9a;
                    color: white;

                    &:hover {
                        border-color: #3f5c9a;
                    }
                }
            }

            .signin-box {
                font-size: 14px;
            }
        }
    }

    @media (max-width: 768px) {
        .layout-container .container .view.login-page {
            margin-left: -5px;
            margin-right: -5px;
            max-width: calc(100% + 10px);
        }
    }
</style>
